// extracted by mini-css-extract-plugin
export default {"page":"App_page__U8AaE","flareAnimation":"App_flareAnimation__LzV0r"};